(function () {
  'use strict';

  function initCarousel(root) {
    if (!root || root.dataset.adhikaInit === '1') return;
    root.dataset.adhikaInit = '1';

    var track = root.querySelector('[data-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var dotsContainer = root.querySelector('[data-dots]');
    var prevBtn = root.querySelector('[data-prev]');
    var nextBtn = root.querySelector('[data-next]');
    var autoplayMs = parseInt(root.getAttribute('data-autoplay'), 10) || 5000;
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!track || slides.length === 0) {
      console.warn('[adhika-testimonials] no track or slides', track, slides.length);
      return;
    }

    var state = { index: 0, perView: 1, positions: 1, timer: null };

    function recalc() {
      var w = window.innerWidth;
      state.perView = w >= 990 ? 3 : (w >= 600 ? 2 : 1);
      state.positions = Math.max(1, slides.length - state.perView + 1);
      if (state.index >= state.positions) state.index = 0;
    }

    function render() {
      var offset = state.index * (100 / state.perView);
      track.style.transform = 'translateX(-' + offset + '%)';
      renderDots();
      if (prevBtn) prevBtn.disabled = state.positions <= 1;
      if (nextBtn) nextBtn.disabled = state.positions <= 1;
    }

    function renderDots() {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = '';
      if (state.positions <= 1) return;
      for (var i = 0; i < state.positions; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'adhika-testimonials__dot' + (i === state.index ? ' is-active' : '');
        btn.setAttribute('aria-label', 'Go to testimonial group ' + (i + 1));
        btn.setAttribute('aria-current', i === state.index ? 'true' : 'false');
        (function (idx) {
          btn.addEventListener('click', function () { goTo(idx); restart(); });
        })(i);
        dotsContainer.appendChild(btn);
      }
    }

    function goTo(i) {
      state.index = ((i % state.positions) + state.positions) % state.positions;
      render();
    }
    function next() { goTo(state.index + 1); }
    function prev() { goTo(state.index - 1); }

    function start() {
      stop();
      if (prefersReducedMotion) return;
      if (state.positions > 1) {
        state.timer = window.setInterval(next, autoplayMs);
      }
    }
    function stop() {
      if (state.timer) { window.clearInterval(state.timer); state.timer = null; }
    }
    function restart() { stop(); start(); }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restart(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); restart(); });

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        recalc(); render(); restart();
      }, 150);
    });

    document.addEventListener('visibilitychange', function () {
      document.hidden ? stop() : start();
    });

    recalc();
    render();
    start();
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-adhika-testimonials]');
    for (var i = 0; i < roots.length; i++) initCarousel(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init in Shopify theme editor (sections reload on change)
  document.addEventListener('shopify:section:load', function (e) {
    var roots = e.target.querySelectorAll('[data-adhika-testimonials]');
    for (var i = 0; i < roots.length; i++) initCarousel(roots[i]);
  });
})();
